import {createSlice} from "@reduxjs/toolkit";

const initialCompanyBrandsState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  companyBrandForEdit: undefined,
  lastError: null
};
export const callTypes = {
  list: "list",
  action: "action"
};

export const companyBrandsSlice = createSlice({
  name: "companyBrands",
  initialState: initialCompanyBrandsState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getcompanyBrandById
    companyBrandFetched: (state, action) => {
      state.actionsLoading = false;
      state.companyBrandForEdit = action.payload.companyBrandForEdit;
      state.error = null;
    },
    // findcompanyBrands
    companyBrandsFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    // createcompanyBrand
    companyBrandCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.entities.push(action.payload.companyBrand);
    },
    // updatecompanyBrand
    companyBrandUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.map(entity => {
        if (entity.id === action.payload.companyBrand.id) {
          return action.payload.companyBrand;
        }
        return entity;
      });
    },
    // deletecompanyBrand
    companyBrandDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(el => el.id !== action.payload.id);
    },
    // deletecompanyBrands
    companyBrandsDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(
        el => !action.payload.ids.includes(el.id)
      );
    }
  }
});
